module.exports = __webpack_public_path__ + "img/substrate-contracts-node.6f39a5bd.png";